module.exports = __webpack_public_path__ + "static/media/dark_alley.d13edd40.jpg";